// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fortune-history-page {
    background-color: transparent;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    position: relative;
}

.fortune-history-home-btn-container {
    position: fixed;
    top: 2rem;
    right: 2rem;
    z-index: 100;
}

/* Home Button */
.fortune-history-home-btn {
    position: fixed;
    top: 2rem;
    right: 2rem;
    z-index: 100;
    width: 50px;
    height: 50px;
    border-radius: 1000px;
    background-color: rgba(218, 194, 158, 0.28);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
    position: relative;
    isolation: isolate;
    color: rgba(213, 190, 155, 1);
}

.fortune-history-home-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 1000px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.fortune-history-home-btn:hover {
    transform: scale(1.1);
    background-color: rgba(0, 0, 0, 0.8);
}

.fortune-history-home-btn:active {
    transform: scale(0.95);
}

.fortune-history-home-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

/* Main Content */
.fortune-history-content {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    padding-top: 2rem;
}

/* Header */
.fortune-history-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    text-align: center;
}

.fortune-history-title {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 2.5rem;
    font-weight: 400;
    color: #D5BE9B;
    margin: 0;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    /* Override global h1 gradient effect */
    background: none;
    background-clip: unset;
    -webkit-text-fill-color: #D5BE9B;
}

.fortune-history-subtitle {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    font-weight: 400;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.05em;
}

/* Records List */
.fortune-records-list {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
}

/* Record Card */
.fortune-record-card {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 2rem;
    padding: 2rem;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 24px;
    transition: all 0.3s ease;
    align-items: start;
    position: relative;
    isolation: isolate;
}

.fortune-record-card::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.fortune-record-card:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

/* Left Section - Question and Info */
.record-content-left {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    grid-column: 1;
    grid-row: 1;
}

.record-question {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1.5rem;
    font-weight: 400;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    line-height: 1.3;
}

.record-subtitle {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    font-weight: 400;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.02em;
    line-height: 1.4;
}

/* Middle Section - Card Placeholders */
.record-cards-preview {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    flex-shrink: 0;
    grid-column: 2;
    grid-row: 1;
    align-self: start;
}

.card-preview-item {
    width: 90px;
    height: 135px;
    background-color: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(213, 190, 155, 0.3);
    border-radius: 8px;
}

/* Bottom Section - DateTime and Buttons */
.record-bottom-section {
    grid-column: 1 / 3;
    grid-row: 2;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 2rem;
}

.record-datetime {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.9rem;
    font-weight: 400;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.02em;
    flex-shrink: 0;
}

/* Right Section - Buttons */
.record-actions {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    flex-shrink: 0;
    align-items: center;
}

.record-action-btn {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.9rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    min-width: 160px;
}

.record-btn-keep {
    background-color: rgba(0, 0, 0, 0.6);
    color: rgba(213, 190, 155, 1);
    border: 1px solid rgba(213, 190, 155, 0.3);
}

.record-btn-keep:hover {
    background-color: rgba(213, 190, 155, 0.1);
    border-color: rgba(213, 190, 155, 0.6);
}

.record-btn-view {
    background-color: rgba(213, 190, 155, 1);
    color: rgba(0, 0, 0, 1);
}

.record-btn-view:hover {
    background-color: rgba(213, 190, 155, 0.9);
    transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 1024px) {
    .fortune-record-card {
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
    }

    .record-content-left {
        grid-column: 1;
        grid-row: 1;
    }

    .record-cards-preview {
        grid-column: 1;
        grid-row: 2;
        justify-content: flex-start;
    }

    .record-bottom-section {
        grid-column: 1;
        grid-row: 3;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .record-actions {
        width: 100%;
        justify-content: flex-end;
    }
}

@media (max-width: 768px) {
    .fortune-history-page {
        padding: 1rem;
    }

    .fortune-history-home-btn {
        top: 1.5rem;
        right: 1.5rem;
    }

    .fortune-history-content {
        gap: 2rem;
        padding-top: 1rem;
    }

    .fortune-history-title {
        font-size: 2rem;
    }

    .fortune-history-subtitle {
        font-size: 0.9rem;
    }

    .fortune-records-list {
        gap: 1.5rem;
    }

    .fortune-record-card {
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
        gap: 1.5rem;
        padding: 1.5rem;
    }

    .record-content-left {
        grid-column: 1;
        grid-row: 1;
        width: 100%;
    }

    .record-question {
        font-size: 1.2rem;
    }

    .record-cards-preview {
        grid-column: 1;
        grid-row: 2;
        width: 100%;
        justify-content: flex-start;
    }

    .record-bottom-section {
        grid-column: 1;
        grid-row: 3;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .record-actions {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }

    .record-action-btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .fortune-history-title {
        font-size: 1.5rem;
        letter-spacing: 0.1em;
    }

    .fortune-history-subtitle {
        font-size: 0.85rem;
    }

    .fortune-record-card {
        padding: 1.2rem;
    }

    .record-question {
        font-size: 1.1rem;
    }

    .record-subtitle {
        font-size: 0.9rem;
    }

    .record-datetime {
        font-size: 0.8rem;
    }

    .card-preview-item {
        width: 70px;
        height: 105px;
    }

    .record-action-btn {
        font-size: 0.85rem;
        padding: 0.65rem 1.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/userCenter/fortuneHistory.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,qBAAqB;IACrB,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;IACtB,yBAAyB;IACzB,uCAAuC;IACvC,gBAAgB;IAEhB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,+BAA+B;IAC/B,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,WAAW;AACf;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;IACtB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;AACJ","sourcesContent":[".fortune-history-page {\r\n    background-color: transparent;\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 2rem;\r\n    position: relative;\r\n}\r\n\r\n.fortune-history-home-btn-container {\r\n    position: fixed;\r\n    top: 2rem;\r\n    right: 2rem;\r\n    z-index: 100;\r\n}\r\n\r\n/* Home Button */\r\n.fortune-history-home-btn {\r\n    position: fixed;\r\n    top: 2rem;\r\n    right: 2rem;\r\n    z-index: 100;\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 1000px;\r\n    background-color: rgba(218, 194, 158, 0.28);\r\n    border: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 0;\r\n    position: relative;\r\n    isolation: isolate;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.fortune-history-home-btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    padding: 1px;\r\n    border-radius: 1000px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.fortune-history-home-btn:hover {\r\n    transform: scale(1.1);\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.fortune-history-home-btn:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.fortune-history-home-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n    object-fit: contain;\r\n}\r\n\r\n/* Main Content */\r\n.fortune-history-content {\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3rem;\r\n    padding-top: 2rem;\r\n}\r\n\r\n/* Header */\r\n.fortune-history-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.fortune-history-title {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 2.5rem;\r\n    font-weight: 400;\r\n    color: #D5BE9B;\r\n    margin: 0;\r\n    letter-spacing: 0.15em;\r\n    text-transform: uppercase;\r\n    /* Override global h1 gradient effect */\r\n    background: none;\r\n    -webkit-background-clip: unset;\r\n    background-clip: unset;\r\n    -webkit-text-fill-color: #D5BE9B;\r\n}\r\n\r\n.fortune-history-subtitle {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n/* Records List */\r\n.fortune-records-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2rem;\r\n    width: 100%;\r\n}\r\n\r\n/* Record Card */\r\n.fortune-record-card {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    grid-template-rows: auto auto;\r\n    gap: 2rem;\r\n    padding: 2rem;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    border-radius: 24px;\r\n    transition: all 0.3s ease;\r\n    align-items: start;\r\n    position: relative;\r\n    isolation: isolate;\r\n}\r\n\r\n.fortune-record-card::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 24px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.fortune-record-card:hover {\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n/* Left Section - Question and Info */\r\n.record-content-left {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n}\r\n\r\n.record-question {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1.5rem;\r\n    font-weight: 400;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n    line-height: 1.3;\r\n}\r\n\r\n.record-subtitle {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.02em;\r\n    line-height: 1.4;\r\n}\r\n\r\n/* Middle Section - Card Placeholders */\r\n.record-cards-preview {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 0.5rem;\r\n    flex-shrink: 0;\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n    align-self: start;\r\n}\r\n\r\n.card-preview-item {\r\n    width: 90px;\r\n    height: 135px;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    border-radius: 8px;\r\n}\r\n\r\n/* Bottom Section - DateTime and Buttons */\r\n.record-bottom-section {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-end;\r\n    gap: 2rem;\r\n}\r\n\r\n.record-datetime {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.9rem;\r\n    font-weight: 400;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.02em;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* Right Section - Buttons */\r\n.record-actions {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 0.75rem;\r\n    flex-shrink: 0;\r\n    align-items: center;\r\n}\r\n\r\n.record-action-btn {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.9rem;\r\n    font-weight: 400;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n    padding: 0.75rem 1.5rem;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    white-space: nowrap;\r\n    min-width: 160px;\r\n}\r\n\r\n.record-btn-keep {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    color: rgba(213, 190, 155, 1);\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n}\r\n\r\n.record-btn-keep:hover {\r\n    background-color: rgba(213, 190, 155, 0.1);\r\n    border-color: rgba(213, 190, 155, 0.6);\r\n}\r\n\r\n.record-btn-view {\r\n    background-color: rgba(213, 190, 155, 1);\r\n    color: rgba(0, 0, 0, 1);\r\n}\r\n\r\n.record-btn-view:hover {\r\n    background-color: rgba(213, 190, 155, 0.9);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1024px) {\r\n    .fortune-record-card {\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: auto auto auto;\r\n    }\r\n\r\n    .record-content-left {\r\n        grid-column: 1;\r\n        grid-row: 1;\r\n    }\r\n\r\n    .record-cards-preview {\r\n        grid-column: 1;\r\n        grid-row: 2;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .record-bottom-section {\r\n        grid-column: 1;\r\n        grid-row: 3;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .record-actions {\r\n        width: 100%;\r\n        justify-content: flex-end;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .fortune-history-page {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .fortune-history-home-btn {\r\n        top: 1.5rem;\r\n        right: 1.5rem;\r\n    }\r\n\r\n    .fortune-history-content {\r\n        gap: 2rem;\r\n        padding-top: 1rem;\r\n    }\r\n\r\n    .fortune-history-title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .fortune-history-subtitle {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .fortune-records-list {\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .fortune-record-card {\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: auto auto auto;\r\n        gap: 1.5rem;\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .record-content-left {\r\n        grid-column: 1;\r\n        grid-row: 1;\r\n        width: 100%;\r\n    }\r\n\r\n    .record-question {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .record-cards-preview {\r\n        grid-column: 1;\r\n        grid-row: 2;\r\n        width: 100%;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .record-bottom-section {\r\n        grid-column: 1;\r\n        grid-row: 3;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .record-actions {\r\n        width: 100%;\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n    }\r\n\r\n    .record-action-btn {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .fortune-history-title {\r\n        font-size: 1.5rem;\r\n        letter-spacing: 0.1em;\r\n    }\r\n\r\n    .fortune-history-subtitle {\r\n        font-size: 0.85rem;\r\n    }\r\n\r\n    .fortune-record-card {\r\n        padding: 1.2rem;\r\n    }\r\n\r\n    .record-question {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .record-subtitle {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .record-datetime {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .card-preview-item {\r\n        width: 70px;\r\n        height: 105px;\r\n    }\r\n\r\n    .record-action-btn {\r\n        font-size: 0.85rem;\r\n        padding: 0.65rem 1.2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
